"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Course = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Item = require("../Item");
var _EnvironmentsModal = require("./partials/EnvironmentsModal");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Course = props => {
  const {
    view = 'default',
    isNew = false,
    url = '',
    banner,
    onItemClick,
    label,
    optionalData,
    isMobileSupported,
    itemTypes,
    title,
    subTitle,
    duration,
    id,
    environments,
    selectedEnvironmentId,
    onConfirmEnvironmentSelect
  } = props;
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
  const handleCourseClick = event => {
    if (onItemClick) {
      onItemClick(event, {
        id,
        url
      });
    } else {
      if (environments.length > 1) {
        event.preventDefault();
        event.stopPropagation();
        setIsModalOpen(true);
      }
    }
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.Item, {
      type: "course",
      view: view,
      url: url,
      onItemClick: handleCourseClick,
      banner: banner,
      title: title,
      subTitle: subTitle,
      itemTypes: itemTypes,
      isMobileSupported: isMobileSupported,
      isNew: isNew,
      duration: duration,
      label: label,
      optionalData: optionalData
    }), isModalOpen && environments?.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnvironmentsModal.EnvironmentsModal, {
      title: title,
      url: url,
      environments: environments,
      onClose: handleModalClose,
      onConfirm: onConfirmEnvironmentSelect,
      selectedEnvironmentId: selectedEnvironmentId
    })]
  });
};
exports.Course = Course;